module.exports = __webpack_public_path__ + "img/star1.9b790055.svg";